export default [
	{  //委外单列表
		path: 'outsourcing',
		name: 'm_outsourcing_order',
		meta: {
			templateManage: {
				workType: 29,
				print: 'b_out_sourcing_printtemplate',
				export: 'b_out_sourcing_exporttemplate'
			},
			appView: {
				viewId: '90020',
				detailView: [{
					name: '详情-任务动态',
					viewId: '90021'
				}],
				auth: 'b_out_sourcing_viewmanage'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/supply/out_sourcing_order_list.vue')
	},
	{  //委外动态
		path: 'outsourcing/process',
		name: 'm_outsourcing_process',
		meta: {
			templateManage: {
				workType: 35,
				print: 'b_outsourcing_process_printtemplate',
				export: 'b_outsourcing_process_exporttemplate'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/supply/out_sourcing_progress_list.vue')
	},
	{  //委外结算单
		path: 'outsourcing/settle',
		name: 'm_outsourcing_settle',
		meta: {
			templateManage: {
				workType: 36,
				print: 'b_outsourcing_settle_printtemplate',
				export: 'b_outsourcing_settle_exporttemplate'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/supply/out_sourcing_settle_list.vue')
	}
];